<template>
    <Title :title="title" />
    <FormIndex
      :stations="true"
      :rangeOfYears="true"
      :variablesContainer="true"
      :radioButton='false'
      :station-type=typeTypology
      :particularMaterial='true'
      :optionsMetodologicalFile="options"
      :view-route='viewRoute'
    />
  </template>

  <script>
  import Title from '../../../components/ViewsTitle/ViewsTitle.vue'
  import FormIndex from '../../../components/forms/FormIndex.vue'
  import TypeTypology from '../../../services/Typologys'
  import options from './optionsAirQualityFileDropdown.js'

  export default {
    name: 'AirQualityForm',
    components: {
      FormIndex,
      Title
    },
    data () {
      return {
        title: 'CONSULTAS A LA BODEGA DE DATOS DE CALIDAD DEL AIRE',
        typeTypology: TypeTypology.airQuality,
        options: options,
        viewRoute: '/resultAirQuality',
      }
    },
    provide () {
      return {
        typology: this.typeTypology,
      }
    }

  }
  </script>